<script>
import { mapActions } from 'vuex';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';
import RbxTextEditor from '@/shared/reybex/RbxTextEditor';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';

export default {
  name: 'BlogEntryDetails',
  components: {
    RbxConfirmDialog,
    RbxTextEditor,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      blogEntry: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
      isDownloading: false,
      categoryName: '',
    };
  },
  created() {
    const { query, params } = this.urlParser('/blogEntryDetails/:id?', this.path);
    this.params = query;
    if (params && params.id) {
      this.params.id = params.id;
    }

    this.fetchData();
  },
  methods: {
    ...mapActions('blogEntryDetails', ['fetchBlogEntry', 'saveBlogEntry']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      if (this.params && this.params.id) {
        this.fetchBlogEntry(this.params)
          .then(({ data }) => {
            this.blogEntry = data;
            this.updateTabTitle({
              path: this.path,
              title: this.blogEntry.headline,
            });
          })
          .catch(() => {
            this.hasError = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.blogEntry = {};
        this.updateTabTitle({
          path: this.path,
          title: 'Neuer Blogeintrag',
        });
        this.isLoading = false;
      }
    },
    save() {
      if (!this.blogEntry.headline) {
        this.showErrorMessage('Bitte tragen Sie einen Titel für den Blogeintrag ein.');
      } else if (!this.blogEntry.text) {
        this.showErrorMessage('Bitte tragen Sie einen Text für den Blogeintrag ein.');
      } else {
        this.isSaving = true;

        this.saveBlogEntry(this.blogEntry)
          .then((response) => {
            this.showSuccessMessage('Der Blogeintrag wurde gespeichert.');
            this.blogEntry = response.data;
          })
          .catch(() => {
            this.showErrorMessage('Der Speichervorgang ist fehlgeschlagen.');
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >Beim Laden des Blogeintrags ist ein technischer Fehler aufgetreten.
    </span>

    <v-form v-else>
      <v-container fluid grid-list-lg pt-2 pa-0>
        <v-toolbar dark dense height="40" color="blue-grey lighten-2">
          <v-tooltip bottom>
            <v-btn @click="save" :loading="isSaving" icon slot="activator">
              <v-icon>save</v-icon>
            </v-btn>
            <span>Speichern</span>
          </v-tooltip>

        </v-toolbar>

        <v-flex xs12 md10 py-0>
          <v-text-field
            v-model="blogEntry.headline"
            label="Titel"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md12 py-0>
          <rbx-text-editor
            v-model="blogEntry.text"
          />
        </v-flex>
      </v-container>
    </v-form>
  </div>
</template>

<style lang="scss">
  // TODO: Format text editor correctly.
  .rbx-text-editor-content {
    height: 600px !important;
  }
</style>
